import React from 'react';
import { ArrowRight } from 'lucide-react';
import Reveal from './Reveal';

export default function FinalCTA({ t }) {
  const c = t.cta;

  return (
    <section className="bg-volt text-ink">
      <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-10 py-20 lg:py-28">
        <Reveal>
          <h2 className="font-display uppercase text-5xl sm:text-7xl lg:text-8xl leading-[0.86] max-w-5xl tracking-tight">
            {c.title}
          </h2>
          <p className="mt-6 text-lg sm:text-xl max-w-xl font-medium leading-relaxed">{c.sub}</p>
          <div className="mt-10 flex flex-col sm:flex-row sm:items-center gap-5">
            <a
              href="/s"
              className="inline-flex items-center justify-center gap-3 px-8 py-4 bg-ink text-snow font-bold uppercase tracking-[0.14em] text-sm hover:bg-snow hover:text-ink transition-colors"
            >
              {c.button}
              <ArrowRight size={18} />
            </a>
            <span className="text-sm font-semibold uppercase tracking-[0.12em]">{c.note}</span>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
